var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-404-page"}},[_c('PageTitle',{attrs:{"title":"404"}}),_c('div',{staticClass:"ma-auto text-center"},[_c('div',{staticClass:"text-h1"},[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('error404.notFoundText')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }